import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  width: 100%;
  bottom: 0;
  height: 0;
  left: 0;
  z-index: 9999;
  text-align: center;
  justify-content: center;
  color: #fff;

  button {
    padding: 5px;
    font-weight: bold;
  }

  @media (min-width: 60em) {
    display: flex;
    bottom: 20px;
  }
`;

export const Content = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  max-width: 1300px;
  padding: 20px 10px;
  position: absolute;
  bottom: 0;

  a{
    color: #fff;
    font-weight: bold;
  }

  @media (min-width: 60em) {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: center;
    border-radius: 25px;
    width: 98%;

    button {
      margin-left: 10px;
      background-color: #f39c12;
      color: #000;
      margin-left: 20px;
      border-radius: 0;
    }
  }
`;